/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText, Stack } from 'sarsaparilla';
import './CampgroundPageV3HeaderPlaceholder.scss';

export default function CampgroundPageV3HeaderPlaceholder() {
    return (
        <div
            id="campground-page-v3-header"
            className="campground-page-v3-header-placeholder"
            aria-hidden="true"
        >
            <Stack space="xs">
                <Placeholder
                    className="campground-page-v3-header-placeholder-title"
                    height="32px"
                    width="75%"
                />
                <div className="campground-page-v3-header-placeholder-near">
                    <PlaceholderText
                        fontSize={23}
                        lineHeight={24}
                        lines={1}
                        width="55%"
                    />
                </div>
                <div className="campground-page-v3-header-placeholder-ratings">
                    <Placeholder height="24px" width="128px" />
                    <div className="campground-page-v3-header-placeholder-divider" />
                    <Placeholder height="24px" width="164px" />
                </div>
            </Stack>
        </div>
    );
}
